import React, { useEffect, useCallback, memo } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { getChanged } from '../../utils/ChangeSpy';
import {
  handleUpdateCompany,
  saveFiscalYear,
  revertUpdate,
  closeValidationError,
} from '../../actions/company/companyTarget';
import { PrettyErrorProvider } from '../../contexts/PrettyErrorContext';
import { usePopupContext } from '../../contexts/PopupContext';

const EditFiscalYearPopupContainer = ({
  children,
  year,
  isValid,
  isNew,
  companyId,
  yearId,
  pathPrefix,
  inputErrors,
  handleUpdateCompany,
  saveFiscalYear,
  revertUpdate,
  closeValidationError,
}) => {
  const context = usePopupContext();

  useEffect(() => {
    context.onClosePopup(() => {
      const field = pathPrefix.slice(0, -1);

      revertUpdate({ field });
    });
  }, [context, pathPrefix, revertUpdate]);

  const onErrorClose = useCallback(
    (event, field) => {
      closeValidationError({ field });
    },
    [closeValidationError],
  );

  const onChange = useCallback(
    event => {
      const { name, value } = event.target;

      return handleUpdateCompany({
        name: `${pathPrefix}${name}`,
        value,
      });
    },
    [pathPrefix, handleUpdateCompany],
  );

  const onSave = useCallback(() => {
    if (isValid) {
      const body = getChanged(year);

      saveFiscalYear({ isNew, yearId, companyId, body }, () => {
        context.closePopup();
      });
    }
  }, [isValid, year, isNew, yearId, companyId, saveFiscalYear, context]);

  return (
    <PrettyErrorProvider inputErrors={inputErrors} onErrorClose={onErrorClose}>
      <div>
        <Popups.EditFiscalYearPopup isNew={isNew} isValid={isValid} onChange={onChange} onSave={onSave} year={year} />
        {children}
      </div>
    </PrettyErrorProvider>
  );
};

function mapStateToProps(state, props) {
  const companyId = props.popup.getIn(['props', 'companyId']);
  const yearId = props.popup.getIn(['props', 'yearId']);
  const isNew = !parseInt(yearId, 10);
  let pathPrefix = 'newYear.';
  let year = state.targetCompany.target.getIn(['newYear']);

  if (!isNew) {
    const yearIndex = state.targetCompany.target.get('targetFiscalYears').findKey(year => year.get('id') === yearId);

    pathPrefix = `targetFiscalYears.${yearIndex}.`;
    year = state.targetCompany.target.getIn(['targetFiscalYears', yearIndex]);
  }

  return {
    isValid: true,
    isNew,
    inputErrors: year.get('inputErrors', Map()),
    companyId,
    year,
    yearId,
    pathPrefix,
  };
}

export { EditFiscalYearPopupContainer };

const Connected = connect(
  mapStateToProps,
  { handleUpdateCompany, saveFiscalYear, revertUpdate, closeValidationError },
  mergeProps,
  connectOptions,
)(memo(EditFiscalYearPopupContainer));

export default Connected;
